/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

import { getLang } from './main.js';
import { setWidgetMode, preloadContentDropdown } from './grid.js';

export function setTemplateLoaderVisibility(show = false) {
    let templateLoader = $('.dd-ajax-loader.dd-template-loader');

    show ? templateLoader.show() : templateLoader.hide();
}

function setTemplateTimerLoaderVisibility(show = false) {
    let templateTimerLoader = $('.dd-ajax-loader.dd-template-timer-loader');

    show ? templateTimerLoader.show() : templateTimerLoader.hide();
}

export function registerTemplateEvents() {
    $('.dd-veditor-template-action').on('click', function () {
        if (!$(this).hasClass('disabled')) {
            $('.dd-templates-modal').modal({backdrop: false, keyboard: false, show: true});
        }
    });

    // Template Timer
    let $timerModal = $('.dd-template-timer-modal');
    $timerModal.modal({backdrop: false, keyboard: false, show: false});
    $('.dd-templates-modal').on('click', '.dd-template-action-preview', function (e) {
        e.preventDefault();

        let templateUrl = $(this).closest('ul.dd-veditor-templates').data('url');
        let oxid = $(this).closest('li').data('oxid');
        $('.dd-template-form input[name=id]').val(oxid);
        $('.dd-template-form input[name=fnc]').val('savePreview');

        $.get(templateUrl + '&fnc=getTemplate&id=' + oxid, function (data) {
            $('.dd-template-form input[name=source]').val(data);

            document.querySelector('#previewModal').setAttribute('data-target', '#templateForm');
            $('#previewModal').modal('show');
        });
    }).on('click', '.dd-template-action-delete', function (e) {
        e.preventDefault();

        let $li = $(this).closest('li');
        let oxid = $li.data('oxid');
        if (oxid) {
            ddh.confirm(ddh.translate('DD_VISUAL_EDITOR_DELETE_TEMPLATE_CONFIRM'), function () {
                $.get(window.VisualEditorInstance.options.actionLink + '&fnc=delete&oxid=' + oxid, function () {
                    $li.remove();
                });
            });
        }
    }).on('click', '.dd-template-action-apply', function (e) {
        e.preventDefault();

        let templateUrl = $(this).closest('ul.dd-veditor-templates').data('url');
        let $li = $(this).closest('li');
        let oxid = $li.data('oxid');
        if (oxid) {
            ddh.confirm(ddh.translate('DD_VISUAL_EDITOR_APPLY_TEMPLATE_CONFIRM'), function () {
                $.get(templateUrl + '&fnc=getTemplate&id=' + oxid, function (data) {
                    setWidgetMode(data, function () {
                        $('.dd-templates-modal').modal('hide');
                    });
                });
            });
        }
    }).on('click', '.dd-template-action-timer', function (e) {
        e.preventDefault();

        let templateUrl = $(this).closest('ul.dd-veditor-templates').data('url');
        let $li = $(this).closest('li');
        let oxid = $li.data('oxid');

        setTemplateLoaderVisibility(true);
        setTemplateTimerLoaderVisibility();

        $.get(templateUrl + '&fnc=getTemplateData&id=' + oxid, function (data) {
            setTemplateLoaderVisibility(false);

            if (data) {
                $('#elm_tmpl_timer_oxid').val(data.id);
                $('#elm_tmpl_timer_name').text(data.title);
                $('#elm_tmpl_timer_date').val((data.targetdate && data.targetdate.substr(0, 10) != '0000-00-00' ? data.targetdate : ''));
                preloadContentDropdown((data.targetid ? data.targetid : ''));
                setTemplateTimerLoaderVisibility(false);
            } else {
                setTemplateTimerLoaderVisibility(false);
            }
            $timerModal.modal('show');
        });
    });

    $('.dd-template-form .form-control').on('keypress', function (e) {
        if (e.keyCode === 13) {
            $('.dd-template-form input[name=source]').val('');
            $('.dd-template-form input[name=oxid]').val('');
            $('.dd-template-form input[name=fnc]').val('save');
        }
    });

    $('.dd-template-timer-form').on('submit', function (e) {
        e.preventDefault();

        let $form = $(this);
        let data = $form.serialize();
        setTemplateTimerLoaderVisibility(true);

        $.post($form.attr('action'), data, function (data) {
            if (!data.error) {
                if (data.tmpl) {
                    let $item = $('.dd-templates-modal .list-group-item[data-oxid="' + data.tmpl.id + '"]');
                    let $info = $item.find('.dd-target-active-info');
                    if (data.tmpl.targetid && data.tmpl.targetdate != '0000-00-00 00:00:00') {
                        if (!$info.length) {
                            $info = $('<small class="text-muted dd-target-active-info"></small>');
                            let $inner = $item.find('.clearfix > .pull-left');
                            $inner.append('<br />');
                            $inner.append($info);
                        }
                        let text = ddh.translate('DD_VISUAL_EDITOR_TEMPLATE_TIMER_ACTIVE_INFO').replace("%s", (data.tmpl.targettitle ? data.tmpl.targettitle : data.tmpl.targetident)).replace("%s", data.tmpl.targetdate.substr(0, 10)).replace("%s", data.tmpl.targetdate.substr(11, 5));
                        $info.html('<i class="fa-solid fa-check"></i> ' + text);
                    } else {
                        if ($info.length) {
                            $info.prev().remove();
                            $info.remove();
                        }
                    }
                }
                $('.dd-template-timer-modal').modal('hide');
            }
        });
    });

    $('.dd-template-action-save').on('click', function (e) {
        e.preventDefault();
        $('.dd-template-form input[name=source]').val('');
        $('.dd-template-form input[name=oxid]').val('');
        $('.dd-template-form input[name=fnc]').val('save');
        $('.dd-template-form').submit();
    });

    $('.dd-template-form').on('submit', function (e) {
        e.preventDefault();

        let $form = $(this);
        let data = $form.serialize();
        if ($('input[name="fnc"]', $form).val() == 'save') {
            if ($('input[name="title"]', $form).val() === '') {
                return;
            }
            $.each(window.VisualEditorInstance.serialize(), function () {
                data += '&widget[' + this.row + '][' + this.col + ']=' + encodeURIComponent(JSON.stringify(this));
            });
        }

        setTemplateLoaderVisibility(true);

        data += '&editlanguage=' + getLang();
        $.post($form.attr('action'), data, function (data) {
            if (!data.error) {
                if (!data.url && data.id) {
                    let $list = $('.dd-templates-modal .dd-veditor-templates');
                    if ($('.no-data', $list).length) {
                        $('.no-data', $list).remove();
                    }
                    let $item = $('<li class="list-group-item" />').attr('data-oxid', data.id);
                    let $itemInner = $('<div class="clearfix" />').appendTo($item);
                    let $titleContainer = $('<div class="pull-left" />').appendTo($itemInner);
                    $titleContainer.append('<span>' + data.title + '</span>');
                    let $actions = $('<div class="pull-right" />').appendTo($itemInner);
                    $actions.append('<button type="button" class="btn btn-xs btn-link dd-template-action-apply"><i class="fa-solid fa-plus" title="' + ddh.translate('DD_VISUAL_EDITOR_TEMPLATE_APPLY_HELP') + '"></i></button>');
                    $actions.append('<button type="button" class="btn btn-xs btn-link dd-template-action-timer"><i class="fa-regular fa-clock" title="' + ddh.translate('DD_VISUAL_EDITOR_TEMPLATE_TIMER_HELP') + '"></i></button>');
                    $actions.append('<button type="button" class="btn btn-xs btn-link dd-template-action-preview"><i class="fa-solid fa-up-right-from-square" title="' + ddh.translate('DD_VISUAL_EDITOR_TEMPLATE_PREVIEW_HELP') + '"></i></button>');
                    $actions.append('<button type="button" class="btn btn-xs btn-link dd-template-action-delete"><i class="fa-solid fa-trash" title="' + ddh.translate('DD_VISUAL_EDITOR_TEMPLATE_DELETE_HELP') + '"></i></button>');
                    $list.prepend($item);
                    $('input[name="title"]', $form).val('');
                }
            } else {
                ddh.alert(data.msg);
            }

            setTemplateLoaderVisibility(false);
        });
    });
}
